import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const images = require.context("../qacmoments", true);
const imageList = images.keys().map((image) => images(image));

function EmblaCarousel() {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 2000,
    fade: true,
    cssEase: "linear",
    adaptiveHeight: false,
    nextArrow: false,
    prevArrow: false,
    arrows: false,
  };
  return (
    <div className=" items-center pt-[120px] bg-[#001ea1] justify-center flex md:px-56">
      <div className="container shadow-2xl shadow-black object-contain ">
        <Slider {...settings}>
          {imageList.map((image, index) => (
            <img key={index} src={image} alt={`image-${index}`} />
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default EmblaCarousel;
